import React, { Component } from 'react';

import { StepWrapper } from '../styles';
import {
	ProgressWrapper,
	ProgressBarLabel,
	ProgressBarBackground,
	ProgressBarMarker,
} from './styles';

export default class UploadProgressBar extends Component {
	render() {
		const { label, value } = this.props;

		return (
			<StepWrapper>
				<ProgressWrapper>
					<ProgressBarLabel>{label}</ProgressBarLabel>
					<ProgressBarBackground>
						<ProgressBarMarker style={{ width: `${value}%` }} />
					</ProgressBarBackground>
				</ProgressWrapper>
			</StepWrapper>
		);
	}
}
